import React from "react";
import "../../../assests/css/teachers/TeacherRegister.css";
import { useNavigate } from "react-router-dom";

const TeacherRegister = () => {
  const navigate = useNavigate();

  
  return (
    <div className="tr-page">
      {/* Left Section */}
      <div className="tr-left">
        <h1>Welcome Teacher</h1>
        <p>
          Join our college management system and manage your classes, exams and
          students easily.
        </p>
        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          alt="Teacher"
        />
      </div>

      {/* Right Section */}
      <div className="tr-right">
        <div className="tr-box">
          <h2>Create Account</h2>
          <p className="tr-subtitle">Teacher Registration</p>

          <form>
            <div className="tr-input-group">
              <label>Full Name</label>
              <input type="text" placeholder="Enter your name" />
            </div>

            <div className="tr-input-group">
              <label>Email</label>
              <input type="email" placeholder="Enter email" />
            </div>

            <div className="tr-input-group">
              <label>Subject / Department</label>
              <input type="text" placeholder="e.g. Mathematics" />
            </div>

            <div className="tr-input-group">
              <label>Password</label>
              <input type="password" placeholder="Create password" />
            </div>

            <button className="tr-register-btn">Register</button>

            <p className="tr-login-text">
              Already have an account?{" "}
              <span onClick={() => navigate("/teacher-login")}>Login</span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TeacherRegister;
